// extracted by mini-css-extract-plugin
module.exports = {"accordionWrapper":"dynamic-link_accordionWrapper__3tHGp","accordionHeaderContainer":"dynamic-link_accordionHeaderContainer__My_JM","link":"dynamic-link_link__osnnw"};